 <template>
  <div class="app-mercedes">
    <div>
      <nav
        class="navbar navbar-light navbar-expand-lg p-0 border-0 shadow"
        style="background: #212121;height:50px"
      >
        <div class="container">
          <a href class="navbar-brand router-link-active" style="display:flex">
            <img :src="peu" width="140px" alt />
            <img :src="sep" width="auto" alt style="margin:0rem 1rem" />
             <router-link to="/mercedes/passenger" style="margin-top: auto;margin-bottom: auto;">
            <img :src="commer" width="120px" alt  style="cursor:pointer" />
            </router-link>
            <span style="padding: 0.5rem 1rem 0rem 1rem"></span>
          </a>
        </div>
      </nav>
    </div>
    <!-- banner -->
    <section class="passengerslider" >
      <el-carousel :interval="5000" arrow="never">
        <el-carousel-item v-for="item in 1" :key="item">
          <div class="container">
            <div class="row">
              <div class="sliderinfo">
                <h5>
                  The all new
                  <span> GT 4 Door Coupé</span>
                </h5>
                <div class="line"></div>
                <h2>Four doors. One air.<br> No compromises.</h2>
                <p>The Mercedes-AMG GT is an incomparable racing icon. Ambitious right from a standing start. Enthralling in every detail. Anyone dreaming of a genuine driving machine will instantly recognise that this is the only way it can look.</p>
                <div style="margin-top:7%">
                  <el-button type="info" style="border: 1.5px solid #00ADEF;background:#00ADEF" @click="gt">
                    EXPLORE MODEL
                    <i class="el-icon-arrow-right" style="padding-left:5%"></i>
                  </el-button>
                  <!-- <el-button class="text" type="text">DISCOVER PEUGEOT</el-button> -->
                </div>
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </section>
    <div class="py-5" style="margin:2rem 0rem">
      <div class="container">
        <div class="" >
          <div style="display:flex" v-for="(promo, i) in homecars" :key="i">
            <div class="carline "></div>

            <div class="row">
              <div class="col-sm-6 col-md-12 col-lg-12" style="margin:0rem 2rem;">
                <h5 class="carname text-uppercase">{{promo.name}}</h5>
                <div class="row">
                  
                  <div
                    class="text-center py-3"
                   
                    v-for="(promocars, i) in promo.cars"
                    :key="i"
                    style="margin-right:1rem"
                  >
                   <router-link class="carroute" :to="'/passenger/' + promocars.url_dash + '/' + promocars.mask">

                  
                  <img :src="promocars.filename" alt width="200px" style="background:#FAFAFA" height="112px" />
                    <!-- <div class="brand"><p class="brandname">C-Class Coupé</p></div> -->
                    <div class="brand">
                      <p class="brandname">{{promocars.name}}</p>
                    </div>
                   </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container py-5">
      <div class="row save" >
        <div class="comforts">
           <div class="py-3 comfortinfo">
          <h2> Mercedes-Maybach GLS</h2>
          <p>A New Form of Luxury<br><br>The Flagship Mercedes-Benz SUV is now available</p>
          <div class="pvbtn" style="margin-top:0%">
            <el-button type="info" style="border: 1.5px solid #00ADEF;background:#00ADEF" @click="contact">
              PRE-ORDER MODEL
              <i class="el-icon-arrow-right" style="padding-left:5%"></i>
            </el-button>
            <!-- <el-button class="text" type="text">DISCOVER PEUGEOT</el-button> -->
          </div>
        </div>
        </div>
       
      </div>
    </div>

    <div class="bg-grey" style="padding-top:3rem">
      <div class="container">
        <core></core>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import CoreValues from "../../components/Core.vue";
var peu = require("../../assets/img/mblogo.svg");
var sep = require("../../assets/img/sep.svg");
var model = require("../../assets/img/models.png");
var commer = require("../../assets/img/passen.svg");

export default {
  name: "Passenger",
  components: {
    core: CoreValues
  },
  data() {
    return { peu, sep, commer, model, homecars: [] };
  },
  metaInfo() {
    return {
      title: "Passenger"
    };
  },
  computed: {},
  methods: {
    details() {
      this.$router.push("/commercial/details");
    },
    fetch_cars() {
      var self = this;
    

      axios.get(APIURL + "brandproduct/mercedes/passenger").then(response => {
        this.homecars = response.data.data;
        console.log(this.homecars);  this.$nextTick(function() {
             
              $(".cardesign").owlCarousel({
                loop: false,
                items: 10,
                 autoWidth:true,
                responsiveClass: true,
                margin:10
              
               
              });
            });

      });
    },
    gt(){
        this.$router.push("/passenger/gt-4-door-coupe/YMQXU8");
    },
    contact() {
      this.$router.push("/contact");
    }
  },
  created() {
    this.fetch_cars();
  }
};
</script>
